import { FC, useState, useRef, useEffect, useContext } from 'react'
import clsx from 'clsx'

import screenSizeContext from 'context/screenSizeContext'

import { MediaNames } from 'constants/media-constanst'
import { ISpeciality } from 'constants/types/common.types'

import style from './lector-bio.module.scss'
import HtmlContainer from 'containers/html-container/html-container'

const desktopHeight = 400
const mobileHeight = 180

interface ILectorBioText {
  description: string
  regalia?: string
  Specialities: ISpeciality[]
}

const screens = [
  MediaNames.MOBILE_SMALL,
  MediaNames.MOBILE,
  MediaNames.TABLET,
  MediaNames.TABLET_MAX,
]

const LectorBioText: FC<ILectorBioText> = ({ description, regalia }: ILectorBioText) => {
  const textRef = useRef<HTMLParagraphElement>(null)
  const [bioClosed, setBioClosed] = useState(false)
  const [toggleFullText, setToggleFullText] = useState(false)

  const { windowSize } = useContext(screenSizeContext)
  const height = screens.includes(windowSize) ? mobileHeight : desktopHeight

  const handleShowFullRegalia = () => setBioClosed((prevState) => !prevState)

  useEffect(() => {
    const text = textRef.current

    if (text && text.offsetHeight > height) {
      setToggleFullText(true)
      setBioClosed(true)
      return
    }

    setToggleFullText(false)
    setBioClosed(false)
  }, [height])

  const gradientStyle = {
    WebkitMaskImage: `linear-gradient(to bottom, black ${height / 3}px, transparent ${
      height - 50
    }px)`,
    maskImage: `linear-gradient(to bottom, black ${height / 3}px, transparent ${height - 50}px)`,
  }

  return (
    <div className={style.bio} style={{ height: bioClosed ? height : 'auto' }}>
      <div
        ref={textRef}
        style={bioClosed ? { ...gradientStyle } : {}}
        className={clsx(style.bioText, {
          [style.bioTextOpened]: toggleFullText,
        })}
      >
        {regalia ? (
          <>
            <p>{regalia}</p>
            <br />
            <br />
          </>
        ) : (
          <></>
        )}
        <HtmlContainer htmlContent={description} />
      </div>

      <div
        className={clsx(style.bottomDone, { [style.shortText]: !toggleFullText })}
        onClick={handleShowFullRegalia}
      >
        <p className={style.bioTextBtn}>{bioClosed ? 'Читать далее' : 'Свернуть'}</p>
      </div>
    </div>
  )
}

export default LectorBioText
